module.exports = __webpack_public_path__ + "static/img/pipelinebenfit2.6d08e771.png";